<template>
    <div class="py-12 bg-indigo-500 relative">
        <div class="flex items-center justify-center w-12 h-12 bg-white rounded-full absolute -top-6 left-1/2 transform -translate-x-1/2"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-4 fill-current text-indigo-500"><path d="M9.983 3v7.391c0 5.704-3.731 9.57-8.983 10.609l-.995-2.151c2.432-.917 3.995-3.638 3.995-5.849h-4v-10h9.983zm14.017 0v7.391c0 5.704-3.748 9.571-9 10.609l-.996-2.151c2.433-.917 3.996-3.638 3.996-5.849h-3.983v-10h9.983z"></path></svg></div>
        <div class="mx-auto lg:w-9/12 w-10/12 text-white">
            <carousel :per-page="1" :autoplay="true" :paginationColor="'#222222'" :paginationActiveColor="'#FFFFFF'">
                <slide v-for="(endorsement, i) in endorsements" :key="i" class="px-8 lg:px-32">
                    <div class="flex lg:flex-row md:flex-col border-b-2 py-3 border-gray-300 lg:justify-between lg:items-center">
                        <div>
                            <h5 class="">
                                <span class="tracking-widest font-medium text-lg">{{ endorsement.name }}</span>
                                <span> - {{ endorsement.designation }}</span>
                            </h5>
                            <div class="text-gray-300">Project: {{ endorsement.project }}</div>
                        </div>
                    </div>
                    <div class="py-3 italic">{{ endorsement.description }}</div>
                </slide>
            </carousel>
        </div>
    </div>
</template>

<script>
export default {
    data: () => {
        return {
            endorsements: [
                {
                    name: "BHASKAR KALITA",
                    designation: "Project Coordinator (Hindustan Homes)",
                    project: "Landing page for real estate company",
                    description: 'Debarshi as a full stack developer has completed numerous real estate website projects for us without any flaw and I really appreciate his clean work.'
                },
                {
                    name: "PRANAB DUARAH",
                    designation: "Systems Officer (GHY High Court)",
                    project: "Judiciary Employee Management System",
                    description: "Debarshi has successfully completed his internship project work entitled 'District Judiciary Employee Management System' at the Hon'ble Gauhati High Court, Guwahati, Assam. During his stay, he has displayed a very sincere and conscious attitude toward his work. His performance during work was found to be excellent."
                }
            ]
        }
    },

}
</script>

<style scoped>
    button{
        outline: none !important;;
    }
</style>